import moment from 'moment';
import TimeFormatter from '../../helpers/TimeFormatter';
import { getHlsParam } from '../../helpers/getHlsParam';
import { ISourceSet } from '../../state/types';
import { getParamAsBoolean } from '../../helpers/getParamAsBoolean';
import { usePrivileges } from '../../state/auth/index.hooks';
import { CAMERAS_RANGE } from '../../constants/videoPlayerSettings';

const CAMERAS = ['MOV1', 'MOV2', 'MOV3', 'MOV4'];

export const parseQueryParams = (queryParams: any) => {
    const {
        timestamp,
        monitoredId,
        selectedCamera,
        rangeMinus,
        rangePlus,
        anonymize,
        labels,
        model,
        confidenceThreshold,
    } = queryParams;

    return {
        timestamp,
        monitoredId,
        selectedCamera,
        anonymize: getParamAsBoolean(anonymize),
        labels: getParamAsBoolean(labels),
        model,
        confidenceThreshold,
        range: [
            -rangeMinus ?? CAMERAS_RANGE[0],
            +rangePlus ?? CAMERAS_RANGE[1],
        ],
    };
};

export const buildFetchParams = (timestamp: string, monitoredId: string) => ({
    api: '/rest/api/source-sets/archive-events',
    label: 'Source',
    method: 'GET',
    params: {
        from: timestamp,
        hiddenParams: false,
        monitoredId,
        reportId: 'archiveEventsWithAttachments',
        to: TimeFormatter.toLocalDate(moment(timestamp).add(5, 'minute')),
        withOrWithoutAttachments: true,
    },
});

export const constructVideoParams = (
    data: ISourceSet,
    camera: string,
    sliderTimeRange: number[],
    privileges: ReturnType<typeof usePrivileges>,
    anonymize?: boolean,
    labels?: boolean,
    model?: string,
    confidenceThreshold?: number
) => {
    const event = Object.values(data.entities)[0].entities?.[0];

    const anonymizeParam = !!(anonymize && privileges.anonymize);
    const labelsParam = !!(labels && privileges.videoProcessingDebug);

    return {
        sliderTimeRange,
        paramName: camera,
        anonymize: anonymizeParam,
        hls: getHlsParam(anonymizeParam, labelsParam),
        eventId: event?.id || '',
        labels: labelsParam,
        model: labelsParam ? model : undefined,
        confidenceThreshold: labelsParam ? confidenceThreshold : undefined,
    };
};

export const getAvailableCamerasIds = (data: ISourceSet) => {
    return Object.keys(
        Object.values(data.entities)[0].entities?.[0] || {}
    ).filter((key) => CAMERAS.includes(key));
};
